import React from 'react';
import { ActionButtonStyled } from '../../../../../components/Wizard/ Wizard.styles';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { TranslationKeys } from '../../../../../translations';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ComparisonInsurerDataFileUpload } from './ComparisonInsurerDataFileUpload';
import type { Connection } from '../../../../../types';
import { InsurerDataRequester } from '../../../../../types';
import { type Comparison } from '../../../../../types/BaselineMeasurements';
import { runConnectionModule } from '../../../../Connections/Services';
import { Uuid } from '../../../../../utils/uuid';

type ComparisonInsurerDataProps = {
  comparisonId: Comparison['comparisonId'] | undefined;
  connectionId: Connection['connectionId'] | undefined;
  onUploadSuccess?: () => void;
  onSyncWithInsurerRequested?: () => void;
  loading?: boolean;
};

export const ComparisonInsurerData = ({
  comparisonId,
  connectionId,
  onUploadSuccess,
  onSyncWithInsurerRequested,
  loading,
}: ComparisonInsurerDataProps) => {
  const syncWithInsurer = () => {
    runConnectionModule({
      connectionId: connectionId,
      moduleType: 'insurance_brydge_fetch_comparison_insurer_data',
      parameters: {
        comparisonId: comparisonId,
        insurerDataRequestId: Uuid.newV4(),
        requester: InsurerDataRequester.BaselineComparison,
      },
    }).then(() => {
      if (onSyncWithInsurerRequested) {
        onSyncWithInsurerRequested();
      }
    });
  };

  return (
    <Stack direction="row" justifyContent="flex-start" alignItems="center" gap={1} sx={{ px: 1 }}>
      <ActionButtonStyled
        data-testid={'comparison-synchronize-with-insurer'}
        icon={faSync}
        messageId={TranslationKeys.global_synchronizeWithInsurer}
        onClick={syncWithInsurer}
        disabled={loading || false}
      />

      <Divider orientation="vertical" flexItem sx={{ display: { xs: 'none', md: 'flex' } }}>
        <Typography textAlign={'center'} margin={1}>
          <FormattedMessage id={TranslationKeys.global_or} />
        </Typography>
      </Divider>

      <Box sx={{ flexGrow: 1 }}>
        <ComparisonInsurerDataFileUpload
          isLoading={loading || false}
          comparisonId={comparisonId}
          connectionId={connectionId}
          onUploadSuccess={onUploadSuccess}
        />
      </Box>
    </Stack>
  );
};
